import { SearchBar } from 'components/SearchBar/SearchBar';
import { styled } from 'libs/ui/styled';

export const SearchBarStyled = styled(SearchBar)({
  width: 252,
});
